import Vue from 'vue'
import VueRouter from 'vue-router'
//import Home from '../views/Home.vue'
// import About from '../views/About.vue'
//import Blog from '../views/Blog.vue'
//import Careers from '../views/Careers.vue'
//import Contact from '../views/Contact.vue'
//import BlogPost from '../components/Blog-post.vue'
//import CareersExpanded from "../components/Careers-expanded.vue";
//import Privacy from '../views/Privacy.vue'
//import Terms from '../views/Terms.vue'
//import DigitalMarketCoordinator from '../components/DigitalMarketingCoordinator.vue';
//import DirectSalesRep from '../components/DirectSalesRep.vue';
//import ValeFinance from '../components/ValeFinance';
//import VantLead from '../components/VantLead'
//import ValeAssetManagment from '../components/ValeAssetManagement'
//import Ambission from '../components/Ambission'
const Home = () => import('../views/Home.vue')
const Blog = () => import('../views/Blog.vue')
const Careers = () => import('../views/Careers.vue')
const Contact = () => import('../views/Contact.vue')
const BlogPost = () => import('../components/Blog-post.vue')
const CareersExpanded = () => import('../components/Careers-expanded.vue')
const Privacy = () => import('../views/Privacy.vue')
const Terms = () => import('../views/Terms.vue')
const DigitalMarketCoordinator = () => import('../components/DigitalMarketingCoordinator.vue')
const DirectSalesRep = () => import('../components/DirectSalesRep.vue')
const ValeFinance = () => import('../components/ValeFinance')
const VantLead = () => import('../components/VantLead')
const ValeAssetManagment = () => import('../components/ValeAssetManagement')
const Ambission = () => import('../components/Ambission')

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/about',
    name: 'About',
    // component: About
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path: '/blog',
    name: 'Blog',
    component: Blog
  },
  {
    path: '/careers',
    name: 'Careers',
    component: Careers
  },
  {
    path: '/contact',
    name: 'Contact',
    component: Contact
  },
  {
    path: '/blog-post',
    name: 'BlogPost',
    component: BlogPost
  },
  {
    path: '/careers-expanded',
    name: 'CareersExpanded',
    component: CareersExpanded
  },
  {
    path: '/privacy',
    name: 'privacy',
    component: Privacy
  },
  {
    path: '/terms',
    name: 'terms',
    component: Terms
  },
  {
    path: '/digital-marketing-coordinator',
    name: 'digitalMarketCoordinator',
    component: DigitalMarketCoordinator
  },
  {
    path: '/direct-sales-representative',
    name: 'directSalesRep',
    component: DirectSalesRep
  },
  {
    path: '/vale-finance',
    name: 'valeFinance',
    component: ValeFinance
  },
  {
    path: '/vantlead-tech',
    name: 'vantLead',
    component: VantLead
  },
  {
    path: '/vale-asset-management',
    name: 'valeAssetManagement',
    component: ValeAssetManagment
  },
  {
    path: '/ambission',
    name: 'ambission',
    component: Ambission
  },
  // {
  //   path: '/about',
  //   name: 'About',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  // }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    return {x: 0, y: 0};
  }
})

export default router
